var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 72,
    height: 70,
    rx: 35,
    fill: "#FFE9D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1663 40.4577C45.5985 41.4071 48.7644 43.1378 51.4163 45.5144L47.5622 50.4169L40.6247 46.5627L42.1663 40.4577ZM42.1663 40.4577C40.1576 39.904 38.0833 39.624 35.9997 39.6252C33.8645 39.6252 31.7955 39.9151 29.833 40.4577M29.833 40.4577C26.4008 41.4071 23.2349 43.1378 20.583 45.5144L24.4372 50.4169L31.3747 46.5627L29.833 40.4577Z",
    stroke: "#E96A0E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.583 38.8538V32.6871H24.0548C24.3462 31.5555 24.7948 30.4871 25.3745 29.5051L22.9186 27.0492L27.2785 22.6894L29.7343 25.1453C30.7276 24.5578 31.7989 24.1135 32.9163 23.8256V20.3538H39.083V23.8256C40.2146 24.117 41.283 24.5656 42.265 25.1453L44.7209 22.6894L49.0807 27.0492L46.6248 29.5051C47.206 30.4871 47.6531 31.5555 47.9445 32.6871H51.4163V38.8538",
    stroke: "#E96A0E",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 35.7698C40.625 34.5432 40.1377 33.3668 39.2704 32.4994C38.403 31.6321 37.2266 31.1448 36 31.1448C34.7734 31.1448 33.597 31.6321 32.7296 32.4994C31.8623 33.3668 31.375 34.5432 31.375 35.7698",
    stroke: "#E96A0E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsMaintenance);
export default __webpack_public_path__ + "static/media/DevOps_Maintenance.70fac2df1a396d69e862aa9a4755e254.svg";
export { ForwardRef as ReactComponent };